module.exports = __webpack_public_path__ + "static/media/user.f500e7fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login/user.svg
// module id = 826
// module chunks = 0